import { render, staticRenderFns } from "./layOutBlog.vue?vue&type=template&id=6ae6a220&scoped=true&lang=html&"
import script from "./layOutBlog.vue?vue&type=script&lang=js&"
export * from "./layOutBlog.vue?vue&type=script&lang=js&"
import style0 from "./layOutBlog.vue?vue&type=style&index=0&id=6ae6a220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6a220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae6a220')) {
      api.createRecord('6ae6a220', component.options)
    } else {
      api.reload('6ae6a220', component.options)
    }
    module.hot.accept("./layOutBlog.vue?vue&type=template&id=6ae6a220&scoped=true&lang=html&", function () {
      api.rerender('6ae6a220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/layOutBlog.vue"
export default component.exports